<template>
    <div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>

            <!-- filter -->
            <b-row v-if="!hasErrors" class="mb-3">
                <b-col md="6" class="my-1">
                </b-col>
                <b-col md="6" class="my-1">
                    <b-form-group label-cols-sm="3" class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input
                                v-model="filter"
                                placeholder="Entrer la valeur recherchée"
                            />
                            <b-input-group-append>
                                <b-button
                                    :disabled="!filter"
                                    @click="filter = ''"
                                >Effacer
                                </b-button
                                >
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- /filter -->

            <!-- Table -->
            <b-table
                responsive
                small
                :items="items"
                :fields="fields"
                :filter="filter"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                primary-key="id"
                @filtered="onFiltered"
            >
            </b-table>
            <!-- /Table -->
            <!-- Pagination -->
            <b-row>
                <b-col md="3" class="my-1 text-center">
                    <b-pagination
                        v-if="totalRows > 0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                        size="sm"
                    ></b-pagination>
                </b-col>
                <b-col md="6" class="my-2">
                    <p class="text-center small pt-0">{{ legend }}</p>
                </b-col>
                <b-col md="3" class="my-1 text-right">
                    <b-dropdown
                        right
                        split
                        size="sm"
                        :text="perPage + ' éléments par page'"
                    >
                        <b-dropdown-item
                            v-for="pageOption in pageOptions"
                            :key="pageOption"
                            @click="setPerPage(pageOption)"
                        >
                            {{ pageOption }}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-col>
            </b-row>
            <!-- /Pagination -->
        </div>
    </div>
</template>

<script>
import loading from '../../../common/components/loading.vue'
import monthChargeHandler from '../../../common/components/MonthChargeHandler.vue'
import DeadLineFilter from '../../../activity_management/activity/components/DeadLineFilter.vue'
import TableHandler from '../../../common/mixins/TableHandler.vue'
import DashboardHandler from '../../mixins/DashboardHandler.vue'

export default {
    name: 'ClientLogs',

    components: {
        DeadLineFilter,
        monthChargeHandler,
        loading,
    },

    mixins: [TableHandler, DashboardHandler],

    data() {
        return {
            fields: [
                {
                    key: 'client_name',
                    label: 'Client',
                    sortable: true,
                },
                {
                    key: 'subject',
                    label: 'Scope',
                    sortable: true,
                },
                {
                    key: 'message',
                    label: 'Message',
                    sortable: true,
                },
                {
                    key: 'created_at',
                    label: 'Fait le',
                    sortable: true,
                },
                {
                    key: 'done_by_initials',
                    label: 'par',
                    sortable: true,
                },
            ],
        }
    },

    created() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'clientLogs')
        this.getItems()
    },

    methods: {
        async getItems() {
            try {
                this.loading = true
                const response = await this.$axios.get(
                    `/reporting/clientLogs`
                )
                this.items = response.data.data
                this.updateTotalRows()
                this.loading = false
            } catch (error) {
                // handle error
                console.log(error)
                this.handleErrors(error.response)
            }
        },
    },
}
</script>

<style scoped></style>
